import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'
import type { IProjectNote } from '../../../Model/Project/IProjectNote.js'

export const AddNoteEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.addNoteRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.addNote(action.payload.projectId, { content: action.payload.note.content }).pipe(
        mergeMap((response: IProjectNote[]) => {
          // Assuming the API returns the newly added note as the last item in the array
          const newNote = response[response.length - 1]
          return of(
            project.addNoteRequestSuccess({
              projectId: action.payload.projectId,
              note: newNote
            })
          )
        }),
        catchError((error) => of(project.addNoteRequestFailure({ error })))
      )
    })
  )
